function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import { Formatter } from '@deephaven/jsapi-utils';
import { EMPTY_ARRAY, EMPTY_MAP } from '@deephaven/utils';
import IrisGridModel from "./IrisGridModel.js";
class EmptyIrisGridModel extends IrisGridModel {
  constructor(dh) {
    var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Formatter(dh);
    super(dh);
    _defineProperty(this, "modelFormatter", void 0);
    _defineProperty(this, "modelColumnAlignmentMap", void 0);
    this.modelFormatter = formatter;
    this.modelColumnAlignmentMap = new Map();
  }
  get rowCount() {
    return 0;
  }
  get columnCount() {
    return 0;
  }
  textForCell(column, row) {
    return '';
  }
  textForColumnHeader(column, depth) {
    return undefined;
  }
  get columns() {
    return EMPTY_ARRAY;
  }
  getColumnIndexByName(name) {
    return undefined;
  }
  get initialMovedColumns() {
    return EMPTY_ARRAY;
  }
  get initialMovedRows() {
    return EMPTY_ARRAY;
  }
  get initialColumnHeaderGroups() {
    return EMPTY_ARRAY;
  }
  get groupedColumns() {
    return EMPTY_ARRAY;
  }
  formatForCell(column, row) {
    return undefined;
  }
  valueForCell(column, row) {
    return undefined;
  }
  get filter() {
    return EMPTY_ARRAY;
  }
  set filter(filter) {
    // No-op
  }
  get partition() {
    return EMPTY_ARRAY;
  }
  set partition(partition) {
    // No-op
  }
  get partitionColumns() {
    return EMPTY_ARRAY;
  }
  get formatter() {
    return this.modelFormatter;
  }
  set formatter(formatter) {
    this.modelFormatter = formatter;
  }
  get columnAlignmentMap() {
    return this.modelColumnAlignmentMap;
  }
  set columnAlignmentMap(columnAlignmentMap) {
    this.modelColumnAlignmentMap = columnAlignmentMap;
  }
  displayString(value, columnType, columnName) {
    return '';
  }
  get sort() {
    return EMPTY_ARRAY;
  }
  set sort(sort) {
    // No-op
  }
  get customColumns() {
    return EMPTY_ARRAY;
  }
  set customColumns(customColumns) {
    // No-op
  }
  get formatColumns() {
    return EMPTY_ARRAY;
  }
  updateFrozenColumns(columns) {
    // Do nothing
  }
  get rollupConfig() {
    return null;
  }
  set rollupConfig(rollupConfig) {
    // No-op
  }
  get totalsConfig() {
    return null;
  }
  set totalsConfig(totalsConfig) {
    // No-op
  }
  export() {
    throw new Error('Method not implemented.');
  }
  columnStatistics(column) {
    throw new Error('Method not implemented.');
  }
  get selectDistinctColumns() {
    return EMPTY_ARRAY;
  }
  set selectDistinctColumns(selectDistinctColumns) {
    // No-op
  }
  get pendingDataMap() {
    return EMPTY_MAP;
  }
  set pendingDataMap(map) {
    // No-op
  }
  get pendingRowCount() {
    return 0;
  }
  set pendingRowCount(count) {
    // No-op
  }
  get pendingDataErrors() {
    return EMPTY_MAP;
  }
  commitPending() {
    return Promise.resolve();
  }
  setViewport(top, bottom, columns) {
    // No-op
  }
  snapshot(ranges) {
    return Promise.resolve([]);
  }
  textSnapshot(ranges, includeHeaders, formatValue) {
    return Promise.resolve('');
  }
  valuesTable(columns) {
    throw new Error('Method not implemented.');
  }
  delete(ranges) {
    return Promise.resolve();
  }
  seekRow(startRow, column, valueType, value, insensitive, contains, isBackwards) {
    return Promise.resolve(0);
  }
  get columnHeaderGroups() {
    return EMPTY_ARRAY;
  }
  set columnHeaderGroups(groups) {
    // No-op
  }
  get columnHeaderGroupMap() {
    return EMPTY_MAP;
  }
  getColumnHeaderParentGroup(modelIndex, depth) {
    return undefined;
  }
}
export default EmptyIrisGridModel;
//# sourceMappingURL=EmptyIrisGridModel.js.map